/**
 * Component: Share Links
 */


 var dnDepartments = dnDepartments || {};

 dnDepartments.shareLinks = dnDepartments.shareLinks || function () {

	this.trigger = function() {
		if ($('.js-popover-button').length) {

			$('.js-popover-button').click(function(e) {
				var popover = $(this).next('.js-popover');
				popover.toggleClass('nc-grid-share-links__popover--active');
			});
		}
	};

	return {
		trigger : trigger
	};
}();